export enum ContractTermPeriodEnum {
    fixedTerm = 'fixedTerm',
    indefinite = 'indefinite',
}
